import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Utils } from "Utils/utils";
import { makeApi, URLS } from "Utils/apiURL";
import AutoCompleteDropdown from "Components/common/AutoCompleteDropdown";
import { accountsState } from "./AccountsState";
import "./accountListFilter.scss";

// Row renderer — mirrors the contacts CustomListBody (same class names, so
// the global common/_customList.scss styles both identically).
const AccountListBody = props => {
  const { name = "", count = "", createTs = "" } = props || {};
  return (
    <>
      <div className="customListLeftSection">
        <span className="updatedName">{name}</span>
        <span className="createdDate">
          {name === "All accounts"
            ? "Default"
            : createTs
            ? `Created on ${Utils.formatDate(createTs)}`
            : ""}
        </span>
      </div>
      <div className="customListRightSection">
        {count !== "" && count !== null && count !== undefined && (
          <>
            <span className="totalContactInList">{count}</span>
            <span className="contactsField">Accounts</span>
          </>
        )}
      </div>
    </>
  );
};

/**
 * Account-list selector rendered INLINE with the "Accounts" page title
 * (HeaderLayout leftChildren) — the same header pattern Contacts uses.
 * Selection flows through accountsState so the table filters reactively.
 */
const AccountListDropdown = observer(() => {
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await makeApi({ url: URLS.accountLists, method: "GET" });
      accountsState.setAccountLists(response?.data?.data || []);
    })();
  }, []);

  if (!accountsState.accountLists.length) return null;

  const active = accountsState.accountLists.find(
    list => list.id === accountsState.activeAccountListId
  );

  return (
    <section className="customListWrapper">
      <div className="customListContainer">
        <AutoCompleteDropdown
          optionList={[
            { id: "", name: "All accounts" },
            ...accountsState.accountLists
          ]}
          defaultValue={active?.name || "All accounts"}
          cbk={item =>
            accountsState.setActiveAccountListId(item && item.id ? item.id : "")
          }
          loader={false}
          showIcon={true}
          icon={
            <i className="material-icons-outlined customListIcon">
              format_list_bulleted
            </i>
          }
          updateListBody={true}
          Body={AccountListBody}
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
        />
      </div>
    </section>
  );
});

export default AccountListDropdown;
